import * as React from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, FormGroup, Grid, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { IProduct } from '../../../../../../data/api/models';
import { get, map } from 'lodash';
import * as Commonmark from 'react-commonmark';
import { FaQuestionCircle } from 'react-icons/fa';
import SelectControl from '../../../../../../components/SelectControl';
import { isRequired } from '../../../../../../util/validators';
import { RenewalSubmitButton } from '../RenewalSubmitButton';
import { MTACardHeader } from '../../../MakeAChange/components/CoverDetails/scenes/Components/MTACardHeader';

interface ChangeMaxTripProps {
  product: IProduct;
  loading: boolean;
  goBackButton: any
}

class ChangeMaxTrip extends React.Component<ChangeMaxTripProps, any> {

  render() {
    const { product, loading, goBackButton } = this.props;

    const popoverClickRootCloseTripExtension = (
      <Popover id="popover-trigger-click-root-close-trip-extension" title="TripExtension">
        <Commonmark
          source={'Annual Multi-Trip policies cover multiple trips of up to 31 days per trip as standard. You can increase the maximum trip duration for the policy term, either up to 45 days or up to 60 days per trip.'}/>
      </Popover>
    );

    const annualTripDuration = map(get(product, 'metadata.annual_trip_durations', {}), (name, key) => {
      return {
        label: name,
        value: parseInt(key, 10),
      };
    });

    return (
      <>
        <div className="admiral-card mt-30">
          <MTACardHeader text={'Please answer the following questions.'}/>
          <div className="body">
            <Grid fluid={true}>
              <div>
                <p
                  style={{ marginTop: '20px' }}>Please confirm the individual trip length.</p>
                <Row className="margin-top dynamic-row">
                  <Col sm={12}>
                    <FormGroup controlId="tripExtension">
                      <Col componentClass={ControlLabel} sm={6}>
                        {'Individual Trip length'}
                        <OverlayTrigger
                          trigger="click"
                          rootClose={true}
                          placement="right"
                          overlay={popoverClickRootCloseTripExtension}
                        ><FaQuestionCircle className="info-btn"/>
                        </OverlayTrigger>
                      </Col>
                      <Col sm={6} className="destinations-inputs">
                        <Field
                          name="maxTripDuration"
                          id="trip-duration-inputs"
                          type="text"
                          component={SelectControl}
                          enableClear={false}
                          forceFilter={false}
                          options={annualTripDuration}
                          validate={[
                            isRequired,
                          ]}
                        /></Col>
                    </FormGroup>
                  </Col>
                </Row>
              </div>
              <div className={'renewal-edit-form-buttons'} style={{ marginBottom: '20px' }}>
                <div className={'renewal-go-back-button'}>
                  {goBackButton}
                </div>
                <div className={'renewal-submit-button'}>
                  <RenewalSubmitButton
                    isLoading={loading}
                  />
                </div>
              </div>
            </Grid>
          </div>
        </div>
      </>
    )
  }
}

export default ChangeMaxTrip;
